import React from 'react';
import debounce from '../modules/debounce.js';

const e = React.createElement;


function AlertBar(props) {
  React.Component.constructor.call(this);

  this.debounced_clearAlert = debounce(props.clearAlert, 7000);
}
AlertBar.prototype = Object.create(React.Component.prototype);

AlertBar.prototype.render = function() {
  var alert = null;
  if(this.props.alert) {
    alert = this.props.alert;
  }

  if(alert) {
    var classNm = (typeof alert.msgtype !== "undefined" && alert.msgtype !== "") ? alert.msgtype : null;
    if(alert.success) classNm = "success";
    this.debounced_clearAlert();
    return e('div', {id:"alert", className:classNm, onClick:this.props.clearAlert.bind(this)}, [
      alert.status && e('strong', {key:""}, alert.status+" "),
      alert.message,
    ]);
  } else {
    return null;
  }
}


export default AlertBar



//////////////////
// WEBPACK FOOTER
// ../_Skelet/src/components/AlertBar.js
// module id = 184
// module chunks = 0